import { default as config } from './config.json'
import { Page0, Page1 } from './ui-components'
import { useState, useEffect } from 'react'
import axios from 'axios'
function App() {

  // Default environment for axios
  axios.defaults.baseURL = config.attributes.apienvironment

  // Get the query parameters
  // They can be used inside the scripts to customize the behavior look on usage example below
  const queryParams = new URLSearchParams(window.location.search);

  // This function can be used to send messages to the parent window 
  // to let site know that app cicle is completed and need to be redirected to the next page in the site flow
  function postMessage(payload) {
    let message = {
      listener: 'e9cc145f-9d03-422e-ba71-1852885998e6',
      payload: payload,
    }
    window.parent.postMessage(message, '*')
    console.log('Message sent to parent window: ' + JSON.stringify(message))
  }

  // Load the DatoCMS configuration from local and execute init script from it
  const [appConfig, setAppConfig] = useState({ ...config })
  const [width, setWidth] = useState(window.innerWidth)
  function handleWindowSizeChange() {
      setWidth(window.innerWidth)
  }
  useEffect(() => {
      window.addEventListener('resize', handleWindowSizeChange)
      return () => {
          window.removeEventListener('resize', handleWindowSizeChange)
      }
  }, [])
  useEffect(() => {
    if (appConfig.attributes.initscript) {
      eval(appConfig.attributes.initscript)
    }
  }, []);
  useEffect(() => {
    if (appConfig.attributes.initscript) {
      eval(appConfig.attributes.initscript)
    }
  }, []);

  // Variables that we can use in the app
  // const [phoneNumber, setPhoneNumber] = useState('')
  // const [dateOfBirth, setDateOfBirth] = useState('')

  const overrides = {
    Page0: {
      width: "100%"
    }
  }

  // Any property of the AWS Amplify component can be overrided in the code or from the DatoCMS configuration
  // For example we can override phone number and date of birth to set the values in variables
  // const overrides = {
  //   TextField4703909: {
  //     onChange: (e) => setDateOfBirth(e.target.value),
  //   },
  //   TextField4703902: {
  //     onChange: (e) => setPhoneNumber(e.target.value),
  //   }
  // };

  // Use the link component implementation
  useLinkComponent()

  // Implementation of the components from the DatoCMS configuration
  // The following example overrides the button onclick event and button text from the DatoCMS configuration
  // In the same way it overrides the labels text
  for (const component of appConfig.attributes.components) {
    overrides[component.attributes.identifier] = {
      ...overrides[component.attributes.identifier],
      id: component.attributes.identifier
    }
    switch (component.attributes.component_type) {
      case 'page':
        if (component.attributes.onclick) {
          overrides[component.attributes.identifier] = {
            ...overrides[component.attributes.identifier],
            onClick: () => eval(component.attributes.onclick)
          }
        }
        break
      case 'button':
        overrides[component.attributes.identifier] = {
          ...overrides[component.attributes.identifier],
          style: {
            cursor: 'pointer'
          }
        }
        if (component.attributes.onclick) {
          overrides[component.attributes.identifier] = {
            ...overrides[component.attributes.identifier],
            onClick: () => eval(component.attributes.onclick)
          }
        }
        if (component.attributes.value) {
          overrides[component.attributes.identifier] = {
            ...overrides[component.attributes.identifier],
            children: component.attributes.value
          }
        }
        break
      case 'label':
        if (component.attributes.value) {
          overrides[component.attributes.identifier] = {
            ...overrides[component.attributes.identifier],
            children: component.attributes.value
          }
        }
        break
      case 'image':
        if (component.attributes.url) {
          overrides[component.attributes.identifier] = {
            ...overrides[component.attributes.identifier],
            backgroundImage: "url('" + component.attributes.url + "')",
            style: {
              "background-size": "cover",
              "background-position": "right"
            }
          }
        }
        break
      default:
        console.log('Override of component: "' + component.attributes.component_type + '" is not implemented')
    }
  }

  // Usage example of the query parameters
  // If the query parameter 'title' is present, override the title of the page
  // if (queryParams.get('title')) {
  //   overrides.Title = {
  //     children: queryParams.get('title')
  //   };
  //   console.log("Title overrided: " + queryParams.get('title'))
  // }

  // Render the AWS Amplify component with the overrided props
  return <Page0 overrides={overrides} />

  // Link Component Implementation
  function useLinkComponent() {

    const [hoverProps, setHoverProps] = useState({})

    for (let i = 1; i <= 10; i++) {
      let component = "ToogleButton" + i
      overrides[component] = {
        ...overrides[component],
        style: { cursor: "pointer" },
        onMouseEnter: () => handleMouseEnter(component),
        onMouseLeave: () => handleMouseLeave(component),
        ...hoverProps[component], // Apply hover styles
      }
    }

    const handleMouseEnter = (component) => {
      setHoverProps((prevProps) => ({
        ...prevProps,
        [component]: {
          variants: "actionHover"
        },
      }))
    }

    const handleMouseLeave = (component) => {
      setHoverProps((prevProps) => ({
        ...prevProps,
        [component]: {
          variants: "default"
        },
      }))
    }
  }
}

export default App;